import { colorNavyD3 } from "../../styles/manualVars";
import Svg from "./Svg";

const Bolt = () => (
  <Svg width={20} height={21}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0581 8.73427C17.2898 8.73427 17.4993 8.86956 17.5946 9.08133C17.6898 9.29309 17.651 9.54015 17.4981 9.71309L8.08632 20.3013C7.97102 20.4307 7.80985 20.499 7.64632 20.499C7.54985 20.499 7.4522 20.4743 7.36279 20.426C7.12279 20.2943 7.00514 20.0131 7.08044 19.7484L9.21926 12.2637H4.11691C3.88514 12.2637 3.67455 12.1284 3.58044 11.9166C3.48632 11.7049 3.52397 11.4578 3.67808 11.2849L13.0898 0.69662C13.271 0.491915 13.5722 0.441326 13.8122 0.571915C14.0522 0.703679 14.1698 0.984856 14.0946 1.24956L11.9557 8.73427H17.0581ZM10.5651 11.8366L8.92044 17.5907L15.7487 9.91074H11.1757C10.991 9.91074 10.8169 9.82486 10.7063 9.67662C10.5946 9.52956 10.5593 9.33897 10.6098 9.16133L12.2546 3.40721L5.42632 11.0872H9.99926C10.184 11.0872 10.3581 11.1731 10.4687 11.3213C10.5804 11.4684 10.6157 11.659 10.5651 11.8366Z"
      fill={colorNavyD3}
    />
  </Svg>
);

export default Bolt;
